import { useEffect, useRef, useState } from 'react';

interface UseInViewportOptions {
  rootMargin?: string;
  threshold?: number;
  once?: boolean;
}

export const useInViewport = <T extends Element>(
  options: UseInViewportOptions = {}
) => {
  const { rootMargin = '120px', threshold = 0.15, once = true } = options;
  const ref = useRef<T | null>(null);
  const [isInViewport, setIsInViewport] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInViewport(true);
          if (once) {
            observer.disconnect();
          }
        } else if (!once) {
          setIsInViewport(false);
        }
      },
      { rootMargin, threshold }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [rootMargin, threshold, once]);

  return { ref, isInViewport };
};
